import axios from 'axios';
import qs from 'qs';
import Http from '../features/core/utils/axios';

const baseDomain = process.env.VUE_APP_BACKEND;
const clientId = process.env.VUE_APP_CLIENT_ID;

export interface LoginCredentials {
    username: string;
    password: string;
}

export interface LoginResponse {
    access_token: string;
    expires_in: number;
    token_type: string;
    scope: string;
    refresh_token: string;
}

export interface RefreshTokenResponse {
    access_token: string;
    expires_in: number;
    token_type: string;
    scope: string;
    refresh_token: string;
}

export interface UserInfo {
    customer: number;
    customer_name: string;
    customer_logo: string;
    customers?: { [key: string]: string };
    id: number;
    email: string;
    username: string;
    name?: string;
    is_smartway?: boolean;
    is_auditor?: boolean;
    google: string | null;
}

export const AuthService = {
    /**
     * Login user with username and password
     */
    login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
        const data = qs.stringify({
            username: credentials.username,
            password: credentials.password,
            grant_type: 'password',
            client_id: clientId
        });

        const response = await axios.post<LoginResponse>(`${baseDomain}/o/token/`, data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });

        return response.data;
    },

    /**
     * Refresh access token using refresh token
     */
    refreshToken: async (refreshToken: string): Promise<RefreshTokenResponse> => {
        const data = qs.stringify({
            refresh_token: refreshToken,
            grant_type: 'refresh_token',
            client_id: clientId
        });

        const response = await axios.post<RefreshTokenResponse>(`${baseDomain}/o/token/`, data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });

        return response.data;
    },

    /**
     * Get current user information including customer logo
     */
    getUserInfo: async (): Promise<UserInfo> => {
        const response = await Http.get<UserInfo>(`${baseDomain}/web/api/me/`);
        return response.data;
    }
};

